import Vue from 'vue';
import App from './components/simple.vue';
import VueCurrencyInput from 'vue-currency-input'
import './assets/styles/index.css';
import ProgressBar from 'vuejs-progress-bar'
import { ButtonGroupPlugin, ButtonPlugin, IconsPlugin } from 'bootstrap-vue'


Vue.use(ButtonGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(IconsPlugin)



Vue.use(ProgressBar)

Vue.config.productionTip = false

const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: 'USD', locale: 'en' }
}
Vue.use(VueCurrencyInput, pluginOptions)

new Vue({
  render: (h) => h(App),
}).$mount('#app');

